// @flow

import React, { Component, Fragment } from "react";
import classNames from "classnames";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import Radio from "../../radio";
import type { RadioWidget as RadioWidgetProps } from "react-jsonschema-form/lib/components/widgets/RadioWidget";

type Props = $Exact<{
  ...RadioWidgetProps,
  options: Object,
}>;

class RadioWidget extends Component<Props> {
  parseValue(value: string) {
    if (this.props.schema.type === "boolean") {
      return value === "true";
    }

    return value;
  }

  handleChange = (event: Object): void => {
    this.props.onChange(
      event.target.value === "" ? this.props.options.value : this.parseValue(event.target.value),
    );
  };

  render() {
    const props = Object.assign({}, this.props, {
      readOnly: this.props.readonly,
      autoFocus: this.props.autofocus,
      onChange: this.handleChange,
    });

    delete props.readonly;
    delete props.formContext;
    delete props.autofocus;
    delete props.rawErrors;
    delete props.registry;
    delete props.schema;

    return (
      <Fragment>
        {props.options.enumOptions.map(option => (
          <Radio
            key={option.value}
            {...Object.assign({}, props, option, {
              id: `${props.id}.${option.value}`,
              name: `${props.id}.${option.value}`,
              className: classNames("mt-1", props.className),
              checked: props.value === option.value,
            })}
          />
        ))}
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </Fragment>
    );
  }
}

export default RadioWidget;
